import React from "react";
import "../styles/Achievements.css";
import { motion } from "framer-motion";

function Achievements({ theme }) {
  return (
    <>
      <motion.div
        className="achievements__main"
        style={{
          backgroundColor: theme === "white" ? "white" : "black",
          color: theme === "white" ? "gray" : "gray",
        }}
        variants={{
          hidden: { opacity: 0, y: 75 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.5, delay: 0.25 }}
      >
        <h1 className="achievements__heading">Achievements</h1>

        <div
          className="achievements__text"
          style={{
            color: theme === "white" ? "gray" : "gray",
          }}
        >
          <div className="achievements__elements">
            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "white"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                IEEEXtreme - Achieved <b>Global Rank 278 and 21 in India,</b>
                IEEEXtreme 14.0.
              </p>
              <br />
            </div>
            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "gray"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                Leetcode
                <a
                  href=" https://leetcode.com/k_joshi/"
                  rel="noreferrer"
                  target="_blank"
                >
                  (k joshi)
                </a>
                :<b>Max Rating 2050+ (Knight - Top 2.13% Worldwide)</b> -
                Maintained a Problem solving streak of over{" "}
                <b>
                  498 days and solved 800+ problems. Achieved Global Rank 107
                  and 13 in India
                </b>
                , Biweekly-Contest-75.
              </p>
              <br />
            </div>
            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "gray"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                Google Kickstart - Secured{" "}
                <b>Global Rank 2574 and 1882 in India</b>, in round A 2022.
              </p>
              <br />
            </div>
            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "gray"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                Codeforces
                <a
                  href="https://codeforces.com/profile/kjoshi_"
                  rel="noreferrer"
                  target="_blank"
                >
                  (kjoshi )
                </a>
                : <b>Max Rating 1446 (Specialist - Top 4.06% in India)</b>-
                Solved over <b>700+</b> problems on the platform and Achieved{" "}
                <b>Global rank 176 and All India Ranks - 15</b> in Codeforces
                Round 835 (Div. 4).
              </p>
              <br />
            </div>
            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "gray"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                Codechef
                <a
                  href="https://www.codechef.com/users/kjoshi2001"
                  rel="noreferrer"
                  target="_blank"
                >
                  (kjoshi2001)
                </a>{" "}
                -{" "}
                <b>
                  {" "}
                  Max Rating 2014 (5 star - Top 3.20% in India) - Achieved
                  Global Rank 25 and 20 in India
                </b>
                , JULY Lunch-Time 2022.
              </p>
              <br />
            </div>

            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "gray"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                <a
                  href="https://auth.geeksforgeeks.org/user/kamleshjoshi18/articles"
                  rel="noreferrer"
                  target="_blank"
                >
                  GeeksforGeeks
                </a>
                - Solved over <b>450+ problems</b> and{" "}
                <b>authored 86+ technical articles</b> focusing on data
                structures and algorithms, contributing to the learning of over{" "}
                <b>700,000+ students worldwide. </b>
              </p>
              <br />
            </div>
            <div className="achievements__first">
              <div className="abt__icon">
                <svg
                  className="svg-icon"
                  fill={theme === "white" ? "gray" : "gray"}
                  viewBox="0 0 20 20"
                >
                  <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
                </svg>
              </div>
              <p>
                <b>Flipkart</b>- Qualified for Flipkart GRiD 4.0 Software
                Development Challenge 2022
              </p>
              <br />
            </div>
          </div>
        </div>

        {/*

                Recent Updates
                    • 
• 
• 
        */}

        <div
          className="achievements__text"
          style={{
            color: theme === "white" ? "gray" : "gray",
          }}
        >
          <h2 className="coding__profiles">
            <u>Coding Profiles</u>
          </h2>

          <h3>
            <p className="coding">{"</>"} Highest rated coder in the college</p>
          </h3>
          <div className="recent__updates__achievements">
            <ul>
              <li>
                Leetcode{" "}
                <a
                  href=" https://leetcode.com/k_joshi/"
                  rel="noreferrer"
                  target="_blank"
                >
                  (k joshi)
                </a>{" "}
                - Max Rating 2050 (Knight - Top 2.13% Worldwide)
              </li>
              <li>
                Codeforces{" "}
                <a
                  href="https://codeforces.com/profile/kjoshi_"
                  rel="noreferrer"
                  target="_blank"
                >
                  (kjoshi )
                </a>{" "}
                - Max Rating 1446 (Specialist - Top 4.06% in India)
              </li>
              <li>
                Codechef{" "}
                <a
                  href="https://www.codechef.com/users/kjoshi2001"
                  rel="noreferrer"
                  target="_blank"
                >
                  (kjoshi2001)
                </a>{" "}
                - Max Rating 2014 (5 star - Top 3.20% in India)
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default Achievements;
